export default {"src":"/_next/static/media/work-inquiries.7e11d3a9.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};